const announcements2021Array = [
    {
        link: "https://iittp.ac.in/recruitment",
        title: "Special Rec. Drive for Ass. Prof. positions - Last date extended (27-12-2021)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Advertisement for HoME staff.pdf",
        title: "Advertisment for HoME Staff",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Advertisement for position of PDF.pdf",
        title: "Advt. for Postdoctral Fellow - Dept. of Physics",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Advt.pdf",
        title: "Advt. for Research Scholar - Dept. of CEE",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/SRF Advertisement.pdf",
        title: "Advertisement for Senior Research Fellow",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/IITT Part-Time Coaches Notification.pdf",
        title: "Notification for Part Time Coaches/GYM Instructor on Contract Basis",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/msphdresults",
        title: "MS/PhD Admissions Results - January 2022",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/recruitment",
        title: "TO Electrical, Dep. Librarian, TO & JT Systems - Results",
        modal: false,
    },
    {
        link: "#researchinternship",
        title: "Advertisement for Vritika (Training And Skill Research Internship)",
        modal: true,
    },
    {
        link: "/doc/LibInfoAssis.pdf",
        title: "Library-Interns - Results",
        modal: false,
    },
    {
        link: "/doc/AR, DR & MO results.pdf",
        title: "Results - Non teaching posts(AR,DR & MO)",
        modal: false,
    },
    {
        link: "/doc/Hindi Consultant Advertisement_12-11-2021.pdf",
        title: "Advertisement for Hindi Consultant-Last Date extended",
        modal: false,
    },
    {
        link: "https://sites.google.com/view/wrtala-2021/",
        title: "Mathematics Workshop - Registration Open",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/information-for-2021-batch",
        title: "Information for B.Tech 2021 students",
        modal: false,
    },
];

export default announcements2021Array;
